<template>
  <div
    class="indicators"
    :class="{
      vertical: variant === 'vertical'
    }"
  >
    <span
      class="indicator"
      v-for="index in numPages"
      :key="index"
      :class="{
        active: index === currentPage,
        horizontal: variant === 'horizontal',
        vertical: variant === 'vertical'
      }"
    ></span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NPageIndicator extends Vue {
  @Prop({ default: 'horizontal', validator: (prop: string) => ['horizontal', 'vertical'].includes(prop) }) variant?:
    | 'horizontal'
    | 'vertical'
  @Prop({ type: Number, default: 0 }) numPages!: number
  @Prop({ type: Number, default: 1 }) currentPage!: number
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.indicators {
  display: flex;

  &.vertical {
    flex-direction: column;
  }

  .indicator {
    height: $notch-space-2x;
    width: $notch-space-2x;
    background-color: $notch-color-neutral-sand-600;
    border-radius: $notch-radius-full;
    display: inline-block;
    &.active {
      background-color: $notch-color-neutral-grey-800;
    }
    &.horizontal:not(:last-child) {
      margin-right: $notch-space-2x;
    }
    &.vertical:not(:last-child) {
      margin-bottom: $notch-space-4x;
    }
  }
}
</style>
